import LogIcon from '@material-ui/icons/PlaylistPlay';
import EventLogList from './eventLogList.js';

export default {
    icon: LogIcon,
    list: EventLogList,
};